module.exports = __webpack_public_path__ + "static/img/lazyload.bb3f9b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/lazyload.png
// module id = 68
// module chunks = 30